import React from 'react';
import { Model, useMetaContext, errorCatch, CollectionServer, updateInArray, GetMetaProperties, deleteInProperties, SetMetaProperties, updateInPropertiesUUID, getObjectDisplay, foreachInProperties, QueryDetail, QueryOrder, POST, GET, GETWITH, useCollectionRef } from 'fennec-ui';
import { Tag } from 'antd';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import PageLayout from '../../components/PageLayout';
import ObjectOwnerDescription from '../../../fedance-ui/ObjectOwnerDescription';
import User from '../../../common/User';
import MDEditor from '@uiw/react-md-editor';
import CopyPolzovateliGruppi from '../../forms/CopyPolzovateliGruppi';

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

const { CheckableTag } = Tag;
var _ = require('lodash');

export default function FederationadministratorSettingsSendingGroups(props) {
    const { auth } = props;
    const meta = useMetaContext();

    const filtersFromMeta = React.useCallback((name) => {
        let prop = [];
        let p = _.get(meta[name], "properties");
        if (p) {
            prop = p?.filter(e => !_.get(e, "relation") || _.get(e, "relation.type") !== "one-many")?.map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))
        }
        return prop;
    }, [meta]);

    const cleanProperties = (obj, context, funcs) => {
        const { name, field, fieldName, contextObject, object } = context;

        if (!obj) { return obj }
        let p = GetMetaProperties(obj)

        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt"])

        //object-owner-description
        if (object && obj.type == "object") {
            p = updateInPropertiesUUID(p, {
                uuid: "object-owner-description",
                type: "func",
                render: () => (<ObjectOwnerDescription object={object} style={{ marginBottom: "5px" }} />)
            }, true)
        }

        //object-context-description
        if (contextObject && obj.type == "object" && field) {
            let fName = _.get(field, "relation.reference.property");
            let o = obj?.properties?.find(e => e.name == fName)
            if (o) {
                let oObj = _.get(o, "relation.reference.object");
                let oMeta = meta[oObj];
                p = updateInPropertiesUUID(p, {
                    uuid: "object-context-description",
                    type: "func",
                    render: () => (<div className='bg bg-grey' style={{ textAlign: "left", padding: "5px", marginBottom: "5px" }}>
                        {(oMeta) && <div style={{
                            fontSize: "10px",
                            color: "rgb(106, 106, 106)",
                            lineHeight: "10px",
                            fontStyle: "italic"
                        }}>{o?.label} ({oMeta?.label})</div>}
                        <div>{getObjectDisplay(contextObject, oObj, meta)}</div>
                        <div style={{ color: "#6a6a6a" }}><ObjectOwnerDescription object={contextObject} inline={true} /></div>
                    </div>)
                }, true)
            }
        }

        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }

        // p = foreachInProperties(p, n => (n.type == "object"), {
        //     queryFilter: [
        //         QueryDetail("collection"),
        //         QueryOrder("ID", "ASC"),
        //     ],
        //     dropdownActions: (value, item, meta, contextObject) => {
        //         let name = item?.relation?.reference?.object;
        //         let m = meta[name]

        //         return [{
        //             title: "Создать",
        //             form: Model,

        //             object: {},

        //             // links: true,
        //             // links: "inline",
        //             // modelActions: (item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
        //             //     return actions.map(e => ({ ...e, meta: cleanProperties(mobject, {name, field, fieldName, contextObject}) }))
        //             // },
        //             // collectionActions: ({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
        //             //     return actions.map(e => ({ ...e, meta: cleanProperties(mobject, {name, field, fieldName, contextObject}) }))
        //             // },

        //             meta: cleanProperties(m, { ...context, contextObject: contextObject }),
        //             action: (values, unlock, close, { collection, setCollection, apply }) => {
        //                 POST(auth, `/api/query-create/${name}`, { ...values },
        //                     ({ data }) => {
        //                         setCollection(updateInArray(collection, data));
        //                         if (apply) {
        //                             apply(data);
        //                         }
        //                         close();
        //                     },
        //                     (err) => errorCatch(err, unlock)
        //                 );
        //             },
        //         },
        //         ]
        //     }
        // })

        p = foreachInProperties(p, n => (n.type == "object" && n.name == "Polzovatel" && n?.relation?.reference?.object == "User"), {
            mode: "dialog",
            relation: {
                uiFilter: () => [
                    {
                        name: "lastname",
                        sort: true,
                        filter: true,
                    },
                    {
                        name: "firstname",
                        sort: true,
                        filter: true,
                    },
                    {
                        name: "patronymic",
                        sort: true,
                        filter: true,
                    },

                    {
                        name: "email",
                        sort: true,
                        filter: true,
                    },
                    {
                        label: "Телефон",
                        name: "phone",
                        sort: true,
                        filter: true,
                    },
                    {
                        name: "gender",
                        sort: true,
                        filter: true,
                        display: (o) => o.name,
                    },
                    {
                        label: "Дата создания",
                        name: "createdAt",
                        type: "date",
                        sort: true,
                        filter: true,
                    },
                ],
                displayString: (item) => {
                    return item?.lastname + " " + item?.firstname
                },
                display: (item) => {
                    return (
                        <User item={item} />
                    )
                },
                reference: { object: "User", property: "ID" },
                type: "many-one",
            },
            dropdownActions: undefined,
            queryFilter: [
                QueryDetail("combobox"),
                QueryOrder("firstname", "ASC")
            ]
        })
        
        p = foreachInProperties(p, n => (n.type == "object" && n.name == "PolzovateliGruppiGruppa" && n?.relation?.reference?.object == "PolzovateliGruppi"), (n)=>({
            relation: {
                ...n?.relation,
                uiFilter: () => [
                    {
                        name: "polzovatel.lastname",
                        sort: true,
                        filter: true,
                    },
                    {
                        name: "polzovatel.firstname",
                        sort: true,
                        filter: true,
                    },
                    {
                        name: "polzovatel.patronymic",
                        sort: true,
                        filter: true,
                    },

                    {
                        name: "polzovatel.email",
                        sort: true,
                        filter: true,
                    },
                    {
                        label: "Телефон",
                        name: "polzovatel.phone",
                        sort: true,
                        filter: true,
                    },
                    {
                        name: "polzovatel.gender",
                        sort: true,
                        filter: true,
                        display: (o) => o.name,
                    },
                    {
                        label: "Дата создания",
                        name: "polzovatel.createdAt",
                        type: "date",
                        sort: true,
                        filter: true,
                    },
                ],
                displayString: (item) => {
                    return item?.polzovatel?.lastname + " " + item?.polzovatel?.firstname
                },
                display: (item) => {
                    return (
                        <div style={{ padding: "0px 5px" }}>
                            <User item={item?.polzovatel} />
                            {item?.opisanie && <div style={{ color: "#6a6a6a" }}>{item?.opisanie}</div>}
                        </div>

                    )
                },
            },
        }))

        p = foreachInProperties(p, n => (n.type == "string" && !n?.db?.size), {
            type: "func",
            render: (auth, item, value, onChange, onAfterChange, isChanged) => {
                return (<MDEditor
                    data-color-mode="light"
                    value={value} onChange={onChange}
                    preview={"edit"}
                    overflow={false}
                />)
            }
        })

        return SetMetaProperties(obj, p)
    }
    // const cref = useCollectionRef()
    return (
        <PageLayout>
            <div style={{ padding: "15px", backgroundColor: "white", borderRadius: "4px" }}>
                <div style={{ paddingTop: "15px" }}>
                    <CollectionServer
                        // collectionRef={cref}
                        auth={auth}
                        name={"GruppiPolzovateleiRassilok"}
                        // queryDetail={"collection"}
                        filters={() => filtersFromMeta("GruppiPolzovateleiRassilok")}

                        mode="list"
                        render={(item, idx) => (
                            <div style={{ padding: "0px 5px" }}>
                                <div>{getObjectDisplay(item, "GruppiPolzovateleiRassilok", meta)}</div>
                                {item?.opisanie && <div style={{ color: "#6a6a6a" }}>{item?.opisanie}</div>}
                            </div>
                        )}

                        linksModelActions={"inline"}

                        scheme={[
                            "PolzovateliGruppiGruppa"//"PolzovateliGruppi",
                        ]}

                        modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                            return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                        }}
                        collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                            let a = actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) }))
                            if (name == "PolzovateliGruppi") {
                                a.push({
                                    action: (values, unlock, close, { collection, setCollection, contextFilters, updateCollection }) => {
                                        // console.log(values, values?.vsetipipolzovatelei?.queryParams, values?.meropriyatieID, values?.eventusers?.queryParams);
                                        if (values?.vsetipipolzovatelei?.queryParams) {
                                            GETWITH(auth, `/api/vsetipipolzovatelei/dobavit-polzovateley-gruppi/${contextObject?.ID}`, values?.vsetipipolzovatelei?.queryParams, ({ data }) => {
                                                if (updateCollection) {
                                                    updateCollection();
                                                }
                                                close()
                                            }, (err) => errorCatch(err, () => unlock()))
                                        } else if (values?.meropriyatieID && values?.eventusers?.queryParams) {
                                            GETWITH(auth, `/api/eventuser/dobavit-polzovateley-gruppi/${contextObject?.ID}/${values?.meropriyatieID}`, values?.eventusers?.queryParams, ({ data }) => {
                                                if (updateCollection) {
                                                    updateCollection();
                                                }
                                                close()
                                            }, (err) => errorCatch(err, () => unlock()))
                                        } else {
                                            unlock()
                                        }
                                    },
                                    title: <i className="fa fa-plus"></i>,
                                    okText: "Добавить в список",
                                    modal: {
                                        width: "40%",
                                        minWidth: "400px",
                                        title: "Добавить пользователей",
                                    },
                                    form: CopyPolzovateliGruppi,
                                })
                                a.push({
                                    action: (values, unlock, close, { collection, setCollection, contextFilters, updateCollection }) => {
                                        if (values?.vsetipipolzovatelei?.queryParams) {
                                            GETWITH(auth, `/api/vsetipipolzovatelei/udalit-polzovateley-gruppi/${contextObject?.ID}`, values?.vsetipipolzovatelei?.queryParams, ({ data }) => {
                                                if (updateCollection) {
                                                    updateCollection();
                                                }
                                                close()
                                            }, (err) => errorCatch(err, () => unlock()))
                                        } else if (values?.meropriyatieID && values?.eventusers?.queryParams) {
                                            GETWITH(auth, `/api/eventuser/udalit-polzovateley-gruppi/${contextObject?.ID}/${values?.meropriyatieID}`, values?.eventusers?.queryParams, ({ data }) => {
                                                if (updateCollection) {
                                                    updateCollection();
                                                }
                                                close()
                                            }, (err) => errorCatch(err, () => unlock()))
                                        } else {
                                            unlock()
                                        }
                                    },
                                    title: <i className="fa fa-minus"></i>,
                                    okText: "Удалить из списка",
                                    modal: {
                                        width: "40%",
                                        minWidth: "400px",
                                        title: "Удалить пользователей",
                                    },
                                    form: CopyPolzovateliGruppi,
                                })
                            }
                            return a
                        }}
                    />
                </div>
            </div>
        </PageLayout>
    );
}
